import type { Theme } from "./theme";

export function Footer({ theme, copyrightYear }: { theme: Theme; copyrightYear: number }) {
  return (
    <footer
      style={{
        position: "absolute",
        bottom: 0,
        left: 0,
        right: 0,
        padding: "20px clamp(20px, 5vw, 40px)",
        fontSize: 13,
        color: theme.fgMute,
        letterSpacing: 0.2,
        display: "flex",
        justifyContent: "center",
        pointerEvents: "none",
      }}
    >
      <div style={{ pointerEvents: "auto", display: "flex", alignItems: "center", gap: 10 }}>
        <span>© {copyrightYear} Rarion</span>
        <span aria-hidden="true">·</span>
        <a href="/privacy" style={{ color: theme.fgMute, textDecoration: "none" }}>
          Privacy
        </a>
        <span aria-hidden="true">·</span>
        <a href="/terms" style={{ color: theme.fgMute, textDecoration: "none" }}>
          Terms
        </a>
      </div>
    </footer>
  );
}
